const { Core, Events } = Global;

customElements.define('main-nav-mobile', class extends Core {
    elements = {
        $: [['level'], 'toolbar']
    }

    render() {
        const currentLevel = Number(this.style.getPropertyValue('--main-nav-mobile-level'));
        this.activeLevel = [0, 1, 2].includes(currentLevel) ? currentLevel : 0;
        this.levelLaunchers = new Map();
        this.sub(Events.HEADER_UPDATE, this._handleHeaderUpdate, { global: true, once: true });
        this.sub(Events.HEADER_TOOLBAR_UPDATE, this._handleToolbarUpdate, { global: true, once: true });
        this.$({
            change: this._handleChange,
            keydown: this._handleKeydown
        });
        this._syncNavigation();
    }

    _handleKeydown(event) {
        const control = event.target.closest('label[role="button"]');
        if (!control || !this.contains(control)) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        control.click();
    }

    _handleChange(event) {
        const input = event.target;
        if (!input.matches('[class~="#main-nav-mobile-level-trigger"]')) return;
        const nextLevel = Number(input.value);
        if (!Number.isInteger(nextLevel) || nextLevel < 0 || nextLevel > 2) return;

        const previousLevel = this.activeLevel;
        let focusTarget;
        if (nextLevel > previousLevel) {
            const launcher = [...this.querySelectorAll('label[for]')]
                .find(label => label.htmlFor === input.id);
            if (launcher) this.levelLaunchers.set(nextLevel, launcher);
            focusTarget = input.nextElementSibling?.querySelector('[role="button"], button, a[href]');
        } else {
            focusTarget = this.levelLaunchers.get(previousLevel);
        }

        this.activeLevel = nextLevel;
        this.style.setProperty('--main-nav-mobile-level', nextLevel);
        this._syncNavigation();
        if (focusTarget?.isConnected && !focusTarget.closest('[inert]')) {
            focusTarget.focus({ preventScroll: true });
        }
    }

    _syncNavigation() {
        this.$('level').forEach(level => {
            const inactive = Number(level.dataset.level) !== this.activeLevel;
            level.inert = inactive;
            level.setAttribute('aria-hidden', String(inactive));
        });
        this.querySelectorAll('label[for][role="button"]').forEach(label => {
            const input = document.getElementById(label.htmlFor);
            if (!input || !this.contains(input)) return;
            const panel = input.nextElementSibling;
            if (!panel) return;
            if (!panel.id) panel.id = `${input.id}-panel`;
            label.setAttribute('aria-controls', panel.id);
            label.setAttribute('aria-expanded', String(input.checked && this.activeLevel >= Number(input.value)));
            if (input.checked) this.levelLaunchers.set(Number(input.value), label);
        });
    }

    _handleHeaderUpdate(items) {
        this.$('level').forEach(level => {
            const match = items.find(item => Number(level.dataset.level) === item.level);
            if (match) level.append(...match.children);
        });
        this._syncNavigation();
    }

    _handleToolbarUpdate(items) {
        this.$('toolbar').append(...items);
    }
});
